.al{flex:1;}